module.exports = __webpack_public_path__ + "ttnyc-logo-hires.jpg?37001c7064f42376d82b41f1e0e2fdb4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/ttnyc-logo-hires.jpg
// module id = 600
// module chunks = 0